module.exports = __webpack_public_path__ + "static/media/circledCheckmark.2513bbd9.svg";